import React, { useEffect } from 'react';

import { useSnackbar } from 'notistack';
import Modal from '@components/Shared/Modal/ModalPure';
import { Form, Input, Spin, Select as SelectAntd } from 'antd';

import { Grid } from '@material-ui/core';
import ButtonComponent from '@src/components/Shared/Buttons/Button';

import Service, { IData } from '../../../services';
import { SaveOutlined } from '@material-ui/icons';

interface IProps {
  controlModal: Function;
  openModal: boolean;
  afterFinish: Function;
  create: 'macro' | 'especifica' | 'motivo' | 'tipoPerfil';
  title: string;
}

const OrigemMacro: React.FC<IProps> = ({
  controlModal,
  openModal,
  afterFinish,
  create,
  title,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = React.useState(false);
  const [origensMacro, setOrigensMacro] = React.useState<IData[]>([]);
  const [origensEspecifica, setOrigensEspecifica] = React.useState<IData[]>([]);

  const getOrigemMacro = async () => {
    const service = new Service();
    const responseOrigemMacro = await service.loadOrigemMacro();

    if (!responseOrigemMacro.error && responseOrigemMacro.response) {
      setOrigensMacro(responseOrigemMacro.response);
    }
  };

  const getOrigemEspecifica = async () => {
    const service = new Service();
    const responseOrigemEspecifica = await service.loadOrigemEspecifica();

    if (!responseOrigemEspecifica.error && responseOrigemEspecifica.response) {
      setOrigensEspecifica(responseOrigemEspecifica.response);
    }
  };

  useEffect(() => {
    if (create === 'especifica') {
      getOrigemMacro();
    }

    if (create === 'motivo') {
      getOrigemEspecifica();
    }
  }, []);

  const onFinish = async (values: any) => {
    var isError = true;
    setLoading(true);
    const service = new Service();

    if (create === 'macro') {
      const { error } = await service.createOrigemMacro({
        descricao: values.descricao,
        status_ativo: 1,
      });
      isError = error;
    } else if (create === 'especifica') {
      const { error } = await service.createOrigemEspecifica({
        origem_macro_id: values.origem_macro_id,
        descricao: values.descricao,
        status_ativo: 1,
      });
      isError = error;
    } else if (create === 'motivo') {
      const { error } = await service.createMotivo({
        descricao: values.descricao,
        origem_especifica_id: values.origem_especifica_id,
        status_ativo: 1,
      });
      isError = error;
    } else if (create === 'tipoPerfil') {
      const { error } = await service.createTipoPerfil({
        descricao: values.descricao,
        status_ativo: 1,
      });
      isError = error;
    }

    if (isError) {
      enqueueSnackbar(`Ocorreu um erro`, {
        title: 'Ocorreu um erro ',
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    } else {
      enqueueSnackbar(`Salvo com sucesso!`, {
        title: 'Cadastro salvo com sucesso!',
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }

    setLoading(false);
    afterFinish();
    controlModal();
  };

  return (
    <>
      <Modal
        title={title}
        size="pequeno"
        openModal={openModal}
        controlModal={controlModal}
      >
        <Spin spinning={loading}>
          <Form
            size="middle"
            layout="horizontal"
            scrollToFirstError={true}
            onFinish={onFinish}
            labelAlign="left"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
          >
            {create === 'especifica' && (
              <Grid item sm={12} xs={12}>
                <Form.Item
                  name="origem_macro_id"
                  label="Origem macro"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Selecione uma origem macro',
                    },
                  ]}
                >
                  <SelectAntd placeholder="Origem macro">
                    {origensMacro.map(item => (
                      <SelectAntd.Option key={item.id} value={item.id}>
                        {item.descricao}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>
            )}

            {create === 'motivo' && (
              <Grid item sm={12} xs={12}>
                <Form.Item
                  name="origem_especifica_id"
                  label="Origem específica"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Selecione uma origem específica',
                    },
                  ]}
                >
                  <SelectAntd placeholder="Origem específica">
                    {origensEspecifica.map(item => (
                      <SelectAntd.Option key={item.id} value={item.id}>
                        {item.descricao}
                      </SelectAntd.Option>
                    ))}
                  </SelectAntd>
                </Form.Item>
              </Grid>
            )}

            <Grid item lg={12} xs={12}>
              <Form.Item
                label="Descrição"
                hasFeedback
                name="descricao"
                rules={[{ required: true, message: 'Campo obrigatorio' }]}
              >
                <Input placeholder="Descrição" maxLength={35} />
              </Form.Item>
              <Grid item sm={12} xs={12} style={{ marginTop: 10 }}>
                <ButtonComponent color="primary" fullWidth type="submit">
                  <SaveOutlined style={{ marginRight: 10 }} /> Salvar
                </ButtonComponent>
              </Grid>
            </Grid>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default OrigemMacro;
